<h4 mat-dialog-title>{{ 'front.modalInfoExpert.information' |translate }} {{ infoExpert?.nom }}
- {{ infoExpert?.prenom }}</h4>

<mat-dialog-content style="min-height: 80px;">
  <div>
    <div>
      {{ 'general.structure' | translate }} : <br>
      <strong>{{ infoExpertLabo?.laboratoireReference?.label }}
      - {{ infoExpertLabo?.laboratoireReference?.adresse?.ville }}</strong>
    </div>
    <div class="mt-1 mb-1">
      {{ 'general.laboratoireLabel' | translate }}  : <br>
      <strong>{{ infoExpertLabo?.nom }} - {{ infoExpertLabo?.adresse?.ville }}</strong>
    </div>
  </div>
  <br>
    <div class="row">
      <div class="col">{{ 'general.motsCle' | translate }} :</div>
      <div class="col"> {{ 'general.discipline' | translate }} :</div>
    </div>
    <br>
      <div class="row">
        @if (infoExpert?.motCles !== null && infoExpert?.motCles.length) {
          <div class="col">
            <mat-chip-set>
              @for (motCle of infoExpert.motCles ; track motCle) {
                <mat-chip color="primary" selected>
                  @for (trad of motCle.translations; track trad; let i = $index) {
                    <span>{{ trad.label }} @if (motCle.translations[i + 1] !== undefined) {
                      <span
                      > - </span>
                    } </span>
                  }
                </mat-chip>
              }
            </mat-chip-set>
          </div>
        }
        @if (infoExpert && infoExpert !== null && infoExpert?.utilisateurDisciplines !== null && infoExpert?.utilisateurDisciplines.length) {
          <div class="col"
            >
            <mat-chip-set>
              @for (ud of infoExpert.utilisateurDisciplines; track ud; let i = $index) {
                <mat-chip color="accent" selected>
                  <span>
                    {{ translationService.getTranslation(ud.discipline)?.label }}
                  </span>
                </mat-chip>
              }
            </mat-chip-set>
          </div>
        }
      </div>
    </mat-dialog-content>
